export const TDI_CONST = {
  API_ERROR: "Error",
  API_SUCCESS: "Success",
  FEEDBACK_SUCCESS: "Thank you for your feedback",
  FEEDBACK_ERROR: "Error in feedback submitting",
  DATA_SYNC_SUCCESS: "Data Sync Successfull",
  DATA_SYNC_ERROR :"Something went wrong"
};
